import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import * as XLSX from 'xlsx';
import { setModoTela, initForm, salvar, excluir, getLista, importarCusto, importarFolha, getListaTipo, getListaItem, getListaVeiculo, getListaUnidade } from './despesaPlacaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import LabelAndInput from '../common/form/labelAndInput';
import { login } from '../auth/authActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import ReactExport from 'react-export-excel-fixed-xlsx';

class DespesaPlaca extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0,
		modoTela: 'quadro',
		tela: 'anual',
		ano: new Date().getFullYear(),
		semestre: `${new Date().getFullYear()}${new Date().getMonth() <= 5 ? '01' : '02'}`,
		trimestre: `${new Date().getFullYear()}${new Date().getMonth() <= 2 ? '01' : (new Date().getMonth() <= 5 ? '02' : (new Date().getMonth() <= 8 ? '03' : '04'))}`,
		mes: `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

	componentDidMount() {

		const initSelectorCusto = () => {
			const fileSelectorCusto = document.createElement('input');
			fileSelectorCusto.setAttribute('type', 'file');
			fileSelectorCusto.addEventListener("change", async (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
						|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
						setError('Selecione apenas (.XLSX)');
						return;
					}

					const planilhas = await this.lerArquivoXLS(file);

					this.props.importarCusto(planilhas[8], planilhas[9]);			

					reader.readAsDataURL(file);

				}

				initSelectorCusto();
			});

			this.fileSelectorCusto = fileSelectorCusto;
		}

		initSelectorCusto();

		const fileSelectorFolha = document.createElement('input');
		fileSelectorFolha.setAttribute('type', 'file');
		fileSelectorFolha.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				const planilhas = await this.lerArquivoXLSFolha(file);

				this.props.importarFolha(planilhas[0]);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelectorFolha = fileSelectorFolha;

	}

    componentWillMount() {
        this.atualizarLista(this.state.ano);
		this.props.getListaTipo();
		this.props.getListaItem();
		this.props.getListaVeiculo();
		this.props.getListaUnidade();
    }

	lerArquivoXLS(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => {
				try {
					const data = new Uint8Array(event.target.result);
					const workbook = XLSX.read(data, { type: 'array' });

					let planilhas = [];

					for (let i = 0; i < workbook.SheetNames.length; i++) {
						const sheetName = workbook.SheetNames[i];
						
						const worksheet = workbook.Sheets[sheetName];
						const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

						let lista = [];
						if (jsonData[0]) {
							lista = jsonData.map(obj => obj);
						}

						planilhas.push({
							nome: sheetName,
							lista: lista
						});
					}

					resolve(planilhas);
				} catch (err) {
					reject(err);
				}
			};

			reader.onerror = reject;
			reader.readAsArrayBuffer(file);
		});
	}

	lerArquivoXLSFolha(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = async (event) => {
				try {
					const data = new Uint8Array(event.target.result);
					const workbook = XLSX.read(data, { type: 'array' });

					let planilhas = [];

					await readXlsxFile(file, { sheet: 1 }).then((rows) => {
						planilhas.push({
							nome: 'Report',
							lista: rows
						});
					}).catch(ex => {
						console.log(ex);						
					});
					
					resolve(planilhas);
				} catch (err) {
					reject(err);
				}
			};

			reader.onerror = reject;
			reader.readAsArrayBuffer(file);
		});
	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					<Row alignCenter>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'anual' ? 'dark' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(this.state.ano, 'anual');
								}}>
								Anual
							</button>
						</Grid>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'semestral' ? 'dark' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(this.state.semestre, 'semestral');
								}}>
								Semestral
							</button>
						</Grid>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'trimestral' ? 'dark' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(this.state.trimestre, 'trimestral');
								}}>
								Trimestral
							</button>
						</Grid>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'mensal' ? 'dark' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(this.state.mes, 'mensal');
								}}>
								Mensal
							</button>
						</Grid>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'periodo' ? 'dark' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(null, 'periodo');
								}}>
								Período
							</button>
						</Grid>
						<Grid cols='12 6 2 2'>
							<button
								type='button' 
								class={`btn btn-block btn-${this.state.tela == 'lista' ? 'dark ' : 'light'} btn-flat`}
								onClick={() => {
									this.atualizarLista(null, 'lista');
								}}>
								Analítico
							</button>
						</Grid>
					</Row>

					{this.lista()}

                </Content>
            </div>
        )
    }

	atualizarLista(value, tela) {

		let dataInicial = null;
		let dataFinal = null;

		if (tela) {
			this.setState({ tela: tela });									
		} else {
			tela = this.state.tela;
		}

		if (tela == 'anual') {
			dataInicial = (this.props.listaAno.filter(item => item.id == value)[0] || {}).dataInicial;
			dataFinal = (this.props.listaAno.filter(item => item.id == value)[0] || {}).dataFinal;
		} else if (tela == 'semestral') {
			dataInicial = (this.props.listaSemestre.filter(item => item.id == value)[0] || {}).dataInicial;
			dataFinal = (this.props.listaSemestre.filter(item => item.id == value)[0] || {}).dataFinal;
		} else if (tela == 'trimestral') {
			dataInicial = (this.props.listaTrimestre.filter(item => item.id == value)[0] || {}).dataInicial;
			dataFinal = (this.props.listaTrimestre.filter(item => item.id == value)[0] || {}).dataFinal;
		} else if (tela == 'mensal') {
			dataInicial = (this.props.listaMes.filter(item => item.id == value)[0] || {}).dataInicial;
			dataFinal = (this.props.listaMes.filter(item => item.id == value)[0] || {}).dataFinal;
		} else if (tela == 'lista' || tela == 'periodo') {
			dataInicial = DateFormat.formatarDataTelaParaSql(value ? value.data_inicial : this.state.data_inicial);
			dataInicial = dataInicial && dataInicial != 'Invalid DateTime' ? dataInicial : null;
			dataFinal = DateFormat.formatarDataTelaParaSql(value ? value.data_final : this.state.data_final);
			dataFinal = dataFinal && dataFinal != 'Invalid DateTime' ? dataFinal : null;
		}

		if (dataInicial && dataFinal) {
			this.props.getLista(dataInicial, dataFinal);
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {
			if (this.state.placas && this.state.placas.split('+').filter(placa => (placa || '').trim()).length
				&& !this.state.placas.split('+').filter(placa => (placa || '').trim()).includes(item.placa_veiculo)) {
				return false;
			}
			if ((this.state.ids_tipos || []).length && !(this.state.ids_tipos || []).includes(item.tipo)) {
				return false;
			}
			if ((this.state.ids_itens || []).length && !(this.state.ids_itens || []).includes(item.nome_item)) {
				return false;
			}
			if ((this.state.ids_unidades || []).length && !(this.state.ids_unidades || []).includes(item.id_unidade)) {
				return false;
			}
			if ((this.state.ids_tipo_veiculos || []).length && !(this.state.ids_tipo_veiculos || []).includes(item.id_tipo_veiculo)) {
				return false;
			}
			if ((this.state.ids_veiculos || []).length && !(this.state.ids_veiculos || []).includes(item.id_veiculo)) {
				return false;
			}
			return true;
		});

		if (this.state.tela != 'lista') {
			let listaAux = [];
			lista.forEach(item => {
				if (!listaAux.filter(itemAux => itemAux.id_veiculo == item.id_veiculo)[0]) {
					listaAux.push({
						id_veiculo: item.id_veiculo,
						placa: item.placa,
						id_tipo_veiculo: item.id_tipo_veiculo,
						km_rodado: item.km_rodado,
						quantidade_abastecida_total: item.quantidade_abastecida_total,
						media_minima: item.media_minima,
						custo_km_meta: item.custo_km_meta,
						nome_unidade: item.nome_unidade,
						dias_motorista: item.dias_motorista,
						dias_total: item.dias_total,
						valor_total: parseFloat(item.valor)
					});
				} else {
					listaAux = listaAux.map(itemAux => {
						if (itemAux.id_veiculo == item.id_veiculo) {
							return {
								...itemAux,
								valor_total: parseFloat((itemAux.valor_total + parseFloat(item.valor)).toFixed(2))
							};
						} else {
							return itemAux;
						}
					});
				}
			});

			lista = listaAux.map(item => ({ ...item }));
		}

		if (this.state.modo != 'lista') {
			lista = lista.map(item => {
				const valorTotal = parseFloat(item.valor_total || 0);
				const kmRodado = parseFloat(item.km_rodado || 0);
				const valorKmRodado = valorTotal > 0 && kmRodado > 0 ? valorTotal / kmRodado : 0;
				const quantidadeAbastecidaTotal = parseFloat(item.quantidade_abastecida_total || 0);
				const media = parseFloat((kmRodado > 0 && quantidadeAbastecidaTotal > 0 ? kmRodado / quantidadeAbastecidaTotal : 0).toFixed(2));
				const mediaMinima = parseFloat(item.media_minima || 0);		
				const metaKm = parseFloat(item.custo_km_meta || 0);
				const diferencaMedia = parseFloat((media - mediaMinima).toFixed(2));
				const diferencaCustoKm = parseFloat((metaKm - valorKmRodado).toFixed(2));

				let ordenacao = 0;
				// if (diferencaMedia < 0.00) {
				// 	ordenacao += Math.abs(diferencaMedia);
				// }
				if (diferencaCustoKm < 0.00) {
					ordenacao += Math.abs(diferencaCustoKm);
				}

				return {
					...item,
					ordenacao: ordenacao
				}			
			});

			lista.sort((a, b) => a.ordenacao > b.ordenacao ? -1 : 1);
		}

		let valorTotalAbastecida = 0;
		let valorTotalFolha = 0;
		let valorTotalOutro = 0;

		if (this.state.tela == 'lista') {
			lista.forEach(item => {
				if (item.tipo == 'Abastecimento') {
					valorTotalAbastecida += parseFloat(item.valor);
				} else if (item.tipo == 'Folha') {
					valorTotalFolha += parseFloat(item.valor);
				} else {
					valorTotalOutro += parseFloat(item.valor);
				}
			});
		}

		return (
			<ContentCard>
				<ContentCardBody>					
					<Row alignCenter>
						{this.state.tela == 'anual' &&
						<Select
							options={this.props.listaAno}
							label='Ano'
							cols='12 4 2 2'
							placeholder='Selecione'
							maxWidth={200}
							value={this.state.ano}
							onChange={value => {
								this.setState({ ano: value });
								this.atualizarLista(value);
							}} />}
					
						{this.state.tela == 'semestral' &&
						<Select
							options={this.props.listaSemestre}
							label='Semestre'
							cols='12 4 2 2'
							placeholder='Selecione'
							maxWidth={200}
							value={this.state.semestre}
							onChange={value => {
								this.setState({ semestre: value });
								this.atualizarLista(value);
							}} />}
					
						{this.state.tela == 'trimestral' &&
						<Select
							options={this.props.listaTrimestre}
							label='Trimestre'
							cols='12 4 2 2'
							placeholder='Selecione'
							maxWidth={200}
							value={this.state.trimestre}
							onChange={value => {
								this.setState({ trimestre: value });
								this.atualizarLista(value);
							}} />}
					
						{this.state.tela == 'mensal' &&
						<Select
							options={this.props.listaMes}
							label='Mês'
							cols='12 4 2 2'
							placeholder='Selecione'
							maxWidth={200}
							value={this.state.mes}
							onChange={value => {
								this.setState({ mes: value });
								this.atualizarLista(value);
							}} />}

						{(this.state.tela == 'lista' || this.state.tela == 'periodo') &&
							<LabelAndInputMask
								label='Data Inicial'
								placeholder='Informe a data'
								minWidth={125}
								maxWidth={125}
								cols='6 6 2 2'
								mask='99/99/9999'
								value={this.state.data_inicial}
								onChange={data => {
									this.setState({ data_inicial: data.target.value });
									this.atualizarLista({ 
										data_inicial: data.target.value,
										data_final: this.state.data_final
									});
								}} />}

						{(this.state.tela == 'lista' || this.state.tela == 'periodo') &&
							<LabelAndInputMask
								label='Data Final'
								placeholder='Informe a data'
								minWidth={125}
								maxWidth={125}
								cols='6 6 2 2'
								mask='99/99/9999'
								value={this.state.data_final}
								onChange={data => {
									this.setState({ data_final: data.target.value });
									this.atualizarLista({ 
										data_inicial: this.state.data_inicial,
										data_final: data.target.value
									});
								}} />}

						<Select
							options={this.props.listaTipo}
							label='Tipo'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={200}
							multiple
							value={this.props.listaTipo.filter(item => (this.state.ids_tipos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_tipos: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={this.props.listaItem}
							label='Item'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={200}
							multiple
							value={this.props.listaItem.filter(item => (this.state.ids_itens || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_itens: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={this.props.listaUnidade}
							label='Base'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={200}
							multiple
							value={this.props.listaUnidade.filter(item => (this.state.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_unidades: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={[
								{ id: 'toco', valor: 'Toco'},
								{ id: 'bitruck', valor: 'Bitruck'},
								{ id: 'carreta', valor: 'Carreta'},
								{ id: 'rodotrem', valor: 'Rodotrem'},
							]}
							label='Tipo de Veículo'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={180}
							multiple
							value={[
								{ id: 'toco', valor: 'Toco'},
								{ id: 'bitruck', valor: 'Bitruck'},
								{ id: 'carreta', valor: 'Carreta'},
								{ id: 'rodotrem', valor: 'Rodotrem'},
							].filter(item => (this.state.ids_tipo_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_tipo_veiculos: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={200}
							multiple
							value={this.props.listaVeiculo.filter(item => (this.state.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_veiculos: (values || []).map(item => item.value) });
							}} />

						<a class='btn btn-app bg-secondary' style={{ marginTop: 8 }}
							onClick={() => this.setState({ modoTela: this.state.modoTela == 'lista' ? 'quadro' : 'lista' })}>
							<i class={this.state.modoTela == 'lista' ? 'fas fa-th-large' : 'fas fa-bars'}></i> {this.state.modoTela == 'lista' ? 'Quadro' : 'Lista'}
						</a>

						{([1, 4, 74].includes(this.props.sessao.id) && this.props.listaTipo.length > 0 && this.props.listaItem.length > 0) &&
						<Grid cols='6 6 3 2' style={{ marginTop: 8, maxWidth: 105 }}>
							<Button
								text='Importar Custos'
								type={'primary'}
								icon={'fa fa-chevron-left'}
								event={() => {
									this.fileSelectorCusto.click();
								}} />
						</Grid>}
						{/*([1, 74].includes(this.props.sessao.id) && this.props.listaTipo.length > 0 && this.props.listaItem.length > 0) &&
						<Grid cols='6 6 3 2' style={{ marginTop: 8, maxWidth: 105 }}>
							<Button
								text='Importar Folha'
								type={'primary'}
								icon={'fa fa-chevron-left'}
								event={() => {
									this.fileSelectorFolha.click();
								}} />
						</Grid>*/}
						<Grid cols='6 6 3 2' style={{ marginTop: 8, maxWidth: 105 }}>
							{this.state.tela == 'lista' ? (
								<ExcelFile
									filename={'Analítico por Período'}
									element={
										<Button
											text='Exportar Excel'
											type={'success'}
											icon={'fa fa-chevron-left'} />
									}>
									<ExcelSheet data={lista.map(item => ({
										...item,
										data_despesa: DateFormat.formatarDataSqlParaTela(item.data_despesa),
										valor: parseFloat(item.valor)
									}))} name={'Analítico por Período'}>
										<ExcelColumn label='Data' value='data_despesa' />
										<ExcelColumn label='Placa' value='placa' />
										<ExcelColumn label='Tipo Veículo' value='id_tipo_veiculo' />
										<ExcelColumn label='Tipo' value='tipo' />
										<ExcelColumn label='Unidade' value='nome_unidade' />
										<ExcelColumn label='Pessoa' value='pessoa' />
										<ExcelColumn label='Código' value='codigo_item' />
										<ExcelColumn label='Item' value='nome_item' />
										<ExcelColumn label='Valor' value='valor' type='number' />
									</ExcelSheet>
								</ExcelFile>
							) : (
								<ExcelFile
									filename={`${this.state.tela == 'anual' ? 'Sintético Anual' : (
										this.state.tela == 'semestral' ? 'Sintético Semestral' : (
											this.state.tela == 'trimestral' ? 'Sintético Trimestral' : (
												this.state.tela == 'mensal' ? 'Sintético Mensal' : (
													this.state.tela == 'periodo' ? 'Sintético por Período' : 'Analítico por Período'
												)
											)
										)
									)}`}
									element={
										<Button
											text='Exportar Excel'
											type={'success'}
											icon={'fa fa-chevron-left'} />
									}>
									<ExcelSheet data={lista.map(item => ({
										...item,
										valor_total: parseFloat(item.valor_total)
									}))} name={`${this.state.tela == 'anual' ? 'Sintético Anual' : (
										this.state.tela == 'semestral' ? 'Sintético Semestral' : (
											this.state.tela == 'trimestral' ? 'Sintético Trimestral' : (
												this.state.tela == 'mensal' ? 'Sintético Mensal' : (
													this.state.tela == 'periodo' ? 'Sintético por Período' : 'Analítico por Período'
												)
											)
										)
									)}`}>
										<ExcelColumn label='Placa' value='placa' />
										<ExcelColumn label='Tipo Veículo' value='id_tipo_veiculo' />
										<ExcelColumn label='Unidade' value='nome_unidade' />
										<ExcelColumn label='Valor Total' value='valor_total' type='number' />
									</ExcelSheet>
								</ExcelFile>
							)}
						</Grid>
					</Row>

					{this.state.tela == 'lista' &&
					<Row>
						<Grid cols='3 3 3 3'>
							<div class='info-box mb-3'>
								<span class='info-box-icon bg-secondary elevation-1'><i class='fas fa-gas-pump'></i></span>

								<div class='info-box-content'>
									<span class='info-box-text'>Abastecidas</span>
									<span class='info-box-number'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalAbastecida, 2)}</span>
								</div>
							</div>
						</Grid>
						<Grid cols='3 3 3 3'>
							<div class='info-box mb-3'>
								<span class='info-box-icon bg-secondary elevation-1'><i class='fas fa-users'></i></span>

								<div class='info-box-content'>
									<span class='info-box-text'>Folha</span>
									<span class='info-box-number'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalFolha, 2)}</span>
								</div>
							</div>
						</Grid>
						<Grid cols='3 3 3 3'>
							<div class='info-box mb-3'>
								<span class='info-box-icon bg-secondary elevation-1'><i class='fas fa-tools'></i></span>

								<div class='info-box-content'>
									<span class='info-box-text'>Outros Custos</span>
									<span class='info-box-number'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalOutro, 2)}</span>
								</div>
							</div>
						</Grid>
						<Grid cols='3 3 3 3'>
							<div class='info-box mb-3'>
								<span class='info-box-icon bg-secondary elevation-1'><i class='fas fa-search-dollar'></i></span>

								<div class='info-box-content'>
									<span class='info-box-text'>Todos os Custos</span>
									<span class='info-box-number'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalAbastecida + valorTotalFolha + valorTotalOutro, 2)}</span>
								</div>
							</div>
						</Grid>
					</Row>}

					{this.state.tela == 'lista' ? (
						<Table responsive>
							<THead>
								<Tr>
									<Th alignCenter>Data</Th>
									<Th alignCenter>Placa</Th>
									<Th alignCenter>Tipo Veículo</Th>
									<Th alignCenter>Tipo</Th>
									<Th alignCenter>Unidade</Th>
									<Th alignCenter>Pessoa</Th>
									<Th alignCenter>Código</Th>
									<Th alignCenter>Item</Th>
									<Th alignRight>Valor</Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map(item => {								
									return (
										<Tr key={item.id}>
											<Td>{DateFormat.formatarDataSqlParaTela(item.data_despesa)}</Td>
											<Td alignCenter>{item.placa}</Td>
											<Td alignCenter>{item.id_tipo_veiculo}</Td>
											<Td alignCenter>{item.tipo}</Td>
											<Td alignCenter>{item.nome_unidade}</Td>
											<Td alignCenter>{item.pessoa}</Td>
											<Td alignCenter>{item.codigo_item}</Td>
											<Td alignCenter>{item.nome_item}</Td>
											<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor, 2)}</Td>
										</Tr>
									);
								})}
								<Tr>
									<Td bold colspan={5}>Abastecidas</Td>
									<Td alignRight bold colspan={4}>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalAbastecida, 2)}</Td>
								</Tr>
								<Tr>
									<Td bold colspan={5}>Folha</Td>
									<Td alignRight bold colspan={4}>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalFolha , 2)}</Td>
								</Tr>
								<Tr>
									<Td bold colspan={5}>Outros Custos</Td>
									<Td alignRight bold colspan={4}>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalOutro, 2)}</Td>
								</Tr>
								<Tr>
									<Td bold colspan={5}>Todos os Custos</Td>
									<Td alignRight bold colspan={4}>R$ {FormatUtils.formatarValorTelaDecimal(valorTotalAbastecida + valorTotalFolha + valorTotalOutro, 2)}</Td>
								</Tr>
							</TBody>
						</Table>
					) : (				
						<>
							{this.state.modoTela == 'quadro' &&
							<Row alignCenter>
								{lista.map(item => {
									return this.componentCard(item);
								})}
							</Row>}

							{this.state.modoTela == 'lista' &&
							<Row alignCenter>
								<Table responsive>
									<THead>
										<Tr>
											<Th alignCenter>Placa</Th>
											<Th alignCenter>Tipo Veículo</Th>
											<Th alignCenter>Unidade</Th>
											<Th alignRight>Custo Total</Th>
											<Th alignRight>Km Rodado</Th>
											<Th alignRight>Custo Km Rodado</Th>
											<Th alignRight></Th>
											<Th alignRight>Média</Th>
											<Th alignRight></Th>
										</Tr>
									</THead>
									<TBody>
										{lista.map(item => {
											
											const valorTotal = parseFloat(item.valor_total || 0);
											const kmRodado = parseFloat(item.km_rodado || 0);
											const valorKmRodado = valorTotal > 0 && kmRodado > 0 ? valorTotal / kmRodado : 0;
											const quantidadeAbastecidaTotal = parseFloat(item.quantidade_abastecida_total || 0);
											const media = parseFloat((kmRodado > 0 && quantidadeAbastecidaTotal > 0 ? kmRodado / quantidadeAbastecidaTotal : 0).toFixed(2));
											const mediaMinima = parseFloat(item.media_minima || 0);		
											const metaKm = parseFloat(item.custo_km_meta || 0);
											const diferencaMedia = parseFloat((media - mediaMinima).toFixed(2));
											const diferencaCustoKm = parseFloat((metaKm - valorKmRodado).toFixed(2));

											return (
												<Tr key={item.id}>
													<Td alignCenter>{item.placa}</Td>
													<Td alignCenter>{item.id_tipo_veiculo}</Td>
													<Td alignCenter>{item.nome_unidade}</Td>
													<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(valorTotal, 2)}</Td>
													<Td alignRight>{FormatUtils.formatarValorTelaDecimal(kmRodado, 2)} km</Td>
													<Td alignRight>{FormatUtils.formatarValorTelaDecimal(valorKmRodado, 2)} R$/km</Td>
													<Td alignLeft>
														<div
															style={{ 
																color: diferencaCustoKm < 0.00 ? '#d10000' : '#3c49fa'
															}}>
															<i class={`fas fa-arrow-${diferencaCustoKm < 0.00 ? 'up' : 'down'}`}
																style={{
																	marginLeft: 8
																}} />
															{FormatUtils.formatarValorTelaDecimal(Math.abs(diferencaCustoKm), 2)}
														</div>
													</Td>
													<Td alignRight>{FormatUtils.formatarValorTelaDecimal(media, 2)} km/h</Td>
													<Td alignLeft>
														<div
															style={{ 
																color: diferencaMedia < 0.00 ? '#d10000' : '#3c49fa'
															}}>
															<i class={`fas fa-arrow-${diferencaMedia > 0.00 ? 'up' : 'down'}`}
																style={{
																	marginLeft: 8
																}} />
															{FormatUtils.formatarValorTelaDecimal(Math.abs(diferencaMedia), 2)}
														</div>
													</Td>
												</Tr>
											);
										})}
									</TBody>
								</Table>
							</Row>}
						</>
					)}
				</ContentCardBody>
			</ContentCard>
		);
	}

	componentCard(registro) {

		const valorTotal = parseFloat(registro.valor_total || 0);
		const kmRodado = parseFloat(registro.km_rodado || 0);
		const valorKmRodado = valorTotal > 0 && kmRodado > 0 ? valorTotal / kmRodado : 0;
		const quantidadeAbastecidaTotal = parseFloat(registro.quantidade_abastecida_total || 0);
		const media = parseFloat((kmRodado > 0 && quantidadeAbastecidaTotal > 0 ? kmRodado / quantidadeAbastecidaTotal : 0).toFixed(2));
		const mediaMinima = parseFloat(registro.media_minima || 0);		
		const metaKm = parseFloat(registro.custo_km_meta || 0);
		const diferencaMedia = parseFloat((media - mediaMinima).toFixed(2));
		const diferencaCustoKm = parseFloat((metaKm - valorKmRodado).toFixed(2));

		let percentualTotal = 0;

		return (
			<Grid cols='12 6 3 2'
				key={registro.id_veiculo}
				style={{
					minWidth: 300
				}}>
				<ContentCard
					style={{
						boxShadow: '0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .50)',
						border: '1px solid rgba(0, 0, 0, .5)'
					}}>
					<ContentCardBody>
						<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }} >
							<div
								style={{
									width: 150
								}}>
							</div>
							<label style={{ width: '100%', textAlign: 'center', margin: 0, paddingTop: 4 }}>
								{registro.placa}
							</label>
							<div style={{ width: 150, display: 'flex', justifyContent: 'end' }}>
								<button
									onClick={() => {
										let dataInicial = null;
										let dataFinal = null;
										if (this.state.tela == 'anual') {
											dataInicial = (this.props.listaAno.filter(item => item.id == this.state.ano)[0] || {}).dataInicial;
											dataFinal = (this.props.listaAno.filter(item => item.id == this.state.ano)[0] || {}).dataFinal;
										} else if (this.state.tela == 'semestral') {
											dataInicial = (this.props.listaSemestre.filter(item => item.id == this.state.semestre)[0] || {}).dataInicial;
											dataFinal = (this.props.listaSemestre.filter(item => item.id == this.state.semestre)[0] || {}).dataFinal;
										} else if (this.state.tela == 'trimestral') {
											dataInicial = (this.props.listaTrimestre.filter(item => item.id == this.state.trimestre)[0] || {}).dataInicial;
											dataFinal = (this.props.listaTrimestre.filter(item => item.id == this.state.trimestre)[0] || {}).dataFinal;
										} else if (this.state.tela == 'mensal') {
											dataInicial = (this.props.listaMes.filter(item => item.id == this.state.mes)[0] || {}).dataInicial;
											dataFinal = (this.props.listaMes.filter(item => item.id == this.state.mes)[0] || {}).dataFinal;
										} else if (this.state.tela == 'periodo') {
											dataInicial = DateFormat.formatarDataTelaParaSql(this.state.data_inicial);
											dataFinal = DateFormat.formatarDataTelaParaSql(this.state.data_final);
										}

										this.setState({
											id_veiculo: registro.id_veiculo,
											data_inicial: DateFormat.formatarDataSqlParaTela(dataInicial),
											data_final: DateFormat.formatarDataSqlParaTela(dataFinal)
										});

										this.atualizarLista({
											data_inicial: DateFormat.formatarDataSqlParaTela(dataInicial),
											data_final: DateFormat.formatarDataSqlParaTela(dataFinal)
										}, 'lista');
									}}
									title='Detalhes'
									style={{
										width: 28,
										height: 28,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										background: '#fff',
										border: '1px solid #ccc',
										borderRadius: 4,
										cursor: 'pointer'
									}} >
									<i class='fas fa-bars'></i>
								</button>
							</div>
						</div>

						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Tipo:
							</div>
							<div style={{ fontSize: 11, textAlign: 'right' }}>
								{registro.id_tipo_veiculo}
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Unidade:
							</div>
							<div style={{ fontSize: 11, textAlign: 'right' }}>
								{registro.nome_unidade || 'Não Alocado'}
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontWeight: 'bold' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Custo Total:
							</div>
							<div style={{ fontSize: 11, textAlign: 'right' }}>
								R$ {FormatUtils.formatarValorTelaDecimal(valorTotal, 2)}
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontWeight: 'bold' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Km Rodado:
							</div>
							<div style={{ fontSize: 11, textAlign: 'right' }}>
								{FormatUtils.formatarValorTelaDecimal(kmRodado, 0)} km
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontWeight: 'bold' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Custo Km Rodado:
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', fontSize: 11 }}>
								<div>
									{FormatUtils.formatarValorTelaDecimal(valorKmRodado, 2)} R$/km
								</div>
								<div
									style={{ 
										color: diferencaCustoKm < 0.00 ? '#d10000' : '#3c49fa'
									}}>
									<i class={`fas fa-arrow-${diferencaCustoKm < 0.00 ? 'up' : 'down'}`}
										style={{
											marginLeft: 8
										}} />
									{FormatUtils.formatarValorTelaDecimal(Math.abs(diferencaCustoKm), 2)}
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontWeight: 'bold' }}>
							<div style={{ fontSize: 11, textAlign: 'left' }}>
								Média:
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', fontSize: 11 }}>
								<div>
									{FormatUtils.formatarValorTelaDecimal(media, 2)} km/l
								</div>
								<div
									style={{ 
										color: diferencaMedia < 0.00 ? '#d10000' : '#3c49fa'
									}}>
									<i class={`fas fa-arrow-${diferencaMedia > 0.00 ? 'up' : 'down'}`}
										style={{
											marginLeft: 8
										}} />
									{FormatUtils.formatarValorTelaDecimal(Math.abs(diferencaMedia), 2)}
								</div>
							</div>
						</div>

						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', fontWeight: 'bold', fontSize: 10 }}>
							Motoristas | % de utilização
						</div>

						<div
							style={{
								height: 60,
								overflowY: 'auto'
							}}>
							{(registro.dias_motorista || []).filter(item => item).map((item, i) => {
								
								let percentual = parseFloat((parseInt(registro.dias_total) > 0 ? (parseInt(item.dias) * 100) / parseInt(registro.dias_total) : 0).toFixed(2));
								if ((registro.dias_motorista || []).filter(item => item).length - 1 == i) {
									percentual = 100 - percentualTotal;
								}
								percentualTotal += percentual;
								
								return (
									<div key={item.nome_motorista} 
										style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
										<div style={{ fontSize: 10, textAlign: 'left' }}>
											{item.nome_motorista}
										</div>
										<div style={{ fontSize: 10, textAlign: 'right' }}>
											{FormatUtils.formatarValorTelaDecimal(percentual, 2)}%
										</div>
									</div>
								);
							})}
						</div>
						
					</ContentCardBody>
				</ContentCard>
			</Grid>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.despesaPlaca.modoTela,
	aguardando: state.despesaPlaca.aguardando,
	listaTipo: state.despesaPlaca.listaTipo,
	listaItem: state.despesaPlaca.listaItem,
	lista: state.despesaPlaca.lista,
	listaAno: state.despesaPlaca.listaAno,
	listaSemestre: state.despesaPlaca.listaSemestre,
	listaTrimestre: state.despesaPlaca.listaTrimestre,
	listaMes: state.despesaPlaca.listaMes,
	listaVeiculo: state.despesaPlaca.listaVeiculo,
	listaUnidade: state.despesaPlaca.listaUnidade
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, importarCusto, importarFolha, getListaTipo, getListaItem, getListaVeiculo, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DespesaPlaca);
